<template>
  <MMPopupDefault class="characteristics-modal" @close="$emit('close')">
    <template #header>
      <MMText font="Title L/Semibold" class="header-title"> Характеристики </MMText>
    </template>

    <div class="modal-content">
      <div v-if="props.onShowData?.characteristics?.list" class="characteristics-list">
        <div
          v-for="(characteristic, index) in props.onShowData.characteristics.list"
          :key="index"
          class="characteristic-group"
        >
          <h3 v-if="characteristic.subtitle" class="subtitle">
            {{ characteristic.subtitle }}
          </h3>
          <ul class="characteristics-sublist">
            <li
              v-for="(value, valueIndex) in characteristic.values"
              :key="valueIndex"
              class="characteristic-item"
            >
              <span class="characteristic-name">{{ value.name }}</span>
              <span class="characteristic-value">{{ value.value }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div v-else class="empty-state">
        <MMText font="Body M/Regular" color="secondary"> Характеристики не найдены </MMText>
      </div>
    </div>
  </MMPopupDefault>
</template>

<script setup lang="ts">
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import type { ICharacteristics } from '../../models/characteristic';

interface IPopupData {
  characteristics: ICharacteristics;
}

const props = defineProps<{ onShowData: IPopupData }>();

defineEmits<{
  close: [];
}>();
</script>

<style scoped lang="stylus">
.characteristics-modal
  width 100%
  max-width 480px
  max-height 80vh

  +Media(Mobile)
    max-width calc(100vw - 32px)
    max-height calc(100vh - 32px)

.header-title
  text-align center

.modal-content
  padding 12px 16px 12px
  max-height 60vh
  overflow-y auto

  +Media(Mobile)
    max-height calc(100vh - 120px)

.characteristics-list
  display flex
  flex-direction column
  gap 24px

.characteristic-group
  .subtitle
    font-size 14px
    font-weight 600
    line-height 20px
    letter-spacing -0.011em
    margin 0 0 14px 0
    color #8b8d98

.characteristics-sublist
  display flex
  flex-direction column
  gap 12px
  margin 0
  padding 0
  list-style none

.characteristic-item
  display grid
  grid-template-columns 2fr 1.5fr
  gap 16px
  align-items start

  .characteristic-name
    font-size 14px
    font-weight 400
    line-height 20px
    letter-spacing -0.005em
    color #8b8d98

  .characteristic-value
    font-size 14px
    font-weight 400
    line-height 20px
    letter-spacing -0.005em
    color #141415
    word-wrap break-word

.empty-state
  display flex
  justify-content center
  align-items center
  padding 40px 20px
  text-align center
</style>
